/**
 * 获取格式为 "yyyy-MM-dd hh:mm:ss" 的实时时间
 * @param {Date} date - 可选，指定日期对象，不传则使用当前时间
 * @returns {String} 格式化后的时间字符串，格式：yyyy-MM-dd hh:mm:ss
 */
export function getRealTime(date) {
	const now = date || new Date();
	const year = now.getFullYear();
	const month = addZero(now.getMonth() + 1);
	const day = addZero(now.getDate());
	const hours = addZero(now.getHours());
	const minutes = addZero(now.getMinutes());
	const seconds = addZero(now.getSeconds());
	
	return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

/**
 * 补零函数
 * @param {Number} num - 需要补零的数字
 * @returns {String} 补零后的字符串
 */
function addZero(num) {
	return num < 10 ? '0' + num : num;
}

/**
 * 默认导出，直接获取当前时间的格式化字符串
 */
export default getRealTime;

